import { analytics } from './index';
import { EVENTS } from './config';

export interface CtaClickParams {
  /**
   * Canonical identifier for this CTA and its placement, e.g. 'final_cta',
   * 'guide_inline', 'tool_bottom', 'jellyfish-alternative-final-primary'.
   * Keep existing values stable so historical PostHog insights keep populating.
   */
  location: string;
  /** Visible button/link text, when meaningful (e.g. 'Find Your #1 Bottleneck'). */
  text?: string;
  /** Where the CTA sends the user (route or URL, e.g. '/login', '/pricing'). */
  destination?: string;
}

/**
 * Single entry point for every "call to action" click across the marketing
 * site and app. Fires one `cta_click` event with a consistent shape so a single
 * funnel can be built on `cta_location`.
 *
 * Backward compatibility: pre-existing insights were keyed on three different
 * property names depending on which component emitted the event -- `source`
 * (useGitHubLogin/FinalCTA/StickyCtaBar), `cta_location` (GuideCTA), and
 * `location` (alternative-page CTAs). We mirror the canonical `location` into
 * all three so no saved insight breaks, while `cta_location` becomes the one
 * key populated for every CTA going forward.
 */
export function trackCtaClick({ location, text, destination }: CtaClickParams): void {
  analytics.track({
    name: EVENTS.CTA_CLICK,
    params: {
      cta_location: location,
      source: location,
      location,
      ...(text !== undefined ? { cta_text: text } : {}),
      ...(destination !== undefined ? { destination } : {}),
    },
  });
}
